import { render } from "./Value4Section.vue?vue&type=template&id=608d7292&scoped=true"
import script from "./Value4Section.vue?vue&type=script&lang=js"
export * from "./Value4Section.vue?vue&type=script&lang=js"

import "./Value4Section.vue?vue&type=style&index=0&id=608d7292&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608d7292"]])

export default __exports__